import React from "react";
import {Heading, Pane} from "evergreen-ui";

export default function ConstructorDefaultPage() {
    return (
        <Pane
            display="flex"
            flex={1}
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            marginLeft='auto'
            marginRight='auto'
            width='90vw'
            height='70vh'
            textAlign='center'
        >
            <Heading size={700} marginTop={-100} marginBottom={16}>Для продолжения работы выберите слева тип конструктора</Heading>
        </Pane>
    )
}

export function createFullStationName(station) {
    if ((station.name === undefined || station.name === "")
        && station.idx === undefined) return ""

    const name = station.name === undefined ? "" : station.name
    const idx = station.idx === undefined ? "" : station.idx
    return "[" + idx + "] " + name;
}

export function createFullStationNameWithOuterIdx(station, idx) {
    if (idx === undefined || idx === "") return ""

    const name = station.name === undefined ? "" : station.name
    return "[" + idx + "] " + name;
}